import { defineComponent as _defineComponent } from 'vue'
import {defineComponent} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';

export default /*#__PURE__*/_defineComponent({
  __name: 'CashSimulationFormStep1',
  setup(__props) {

const store = useSimulationStore();


return { __sfc: true,store, I18NGetter }
}

})